import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import navbar_left_vector from "../../assets/images/svg/navbar_left_vector.svg";
import navbar_right_vector from "../../assets/images/svg/navbar_right_vector.svg";
import new_logo from "../../assets/images/webp/NEW_LOGO.webp";
import { CrossIcon, DropdownArrowIcon, HumburgerMenu } from "./icons/Icons";
import { linksList, socialLinksList } from "../../utils/NavbarHelper";

const Header = () => {
  const location = useLocation();
  const [head, setHead] = useState(true);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  function showNavBar() {
    setHead(!head);
  }

  const toggleSubmenu = (index, event) => {
    event.preventDefault();
    event.stopPropagation();
    setActiveSubmenu(activeSubmenu === index ? null : index);
  };

  if (!head) {
    document.body.classList.add("scroll_hidden");
  } else {
    document.body.classList.remove("scroll_hidden");
  }

  return (
    <>
      {head ? (
        ""
      ) : (
        <div
          className="nav_overlay position-absolute top-0 start-0 vh-100 w-100 transition_03"
          onClick={showNavBar}
        ></div>
      )}
      <nav className="container container_modified position-absolute navbar_parent py-3 px-sm-4 px-sm-4 bg-white d-flex align-items-center justify-content-between flex-wrap">
        <img
          className="h-100 position-absolute start-0 navbar_left_vector"
          src={navbar_left_vector}
          alt="navbar_left_vector"
        />
        <img
          className="h-100 position-absolute end-0 navbar_right_vector"
          src={navbar_right_vector}
          alt="navbar_right_vector"
        />
        <Link className="nav_logo position-absolute start-50 translate-middle-x" to="/">
          <img 
            src={new_logo} 
            alt="logo" 
            className="logo-img"
            style={{
              maxWidth: '100%',
              height: 'auto',
              maxHeight: '60px',
              objectFit: 'contain'
            }}
          />
        </Link>
        <span onClick={showNavBar} className="d-md-none">
          {head ? <HumburgerMenu /> : <CrossIcon />}
        </span>
        <div
          className={`nav_links d-flex flex-column flex-md-row align-items-start transition_03 ${head ? "hidden_nav_links" : ""
            }`}
        >
          {linksList.map((obj, index) => {
            return (
              <div key={index} className="nav-item position-relative">
                {obj.submenu ? (
                  <div className="d-flex align-items-center">
                    <Link
                      className={`text-decoration-none font-sm fw-medium text-dark-gray underline_hover position-relative close_nav d-flex align-items-center ${location.pathname === obj.to ? "active_link" : "opacity-75"}`}
                      to={obj.to}
                      onClick={(e) => toggleSubmenu(index, e)}
                    >
                      {obj.title}
                      <DropdownArrowIcon className="ms-2 my-auto" />
                    </Link>
                  </div>
                ) : (
                  <Link
                    className={`text-decoration-none font-sm fw-medium text-dark-gray underline_hover position-relative close_nav ${location.pathname === obj.to ? "active_link" : "opacity-75"}`}
                    onClick={() => setHead(true)}
                    to={obj.to}
                  >
                    {obj.title}
                  </Link>
                )}
                {obj.submenu && (
                  <div className={`submenu ${activeSubmenu === index ? 'active' : ''}`}>
                    {obj.submenu.map((subItem, subIndex) => (
                      <Link
                        key={subIndex}
                        className="d-block text-decoration-none font-sm fw-medium text-dark-gray"
                        to={subItem.to}
                        onClick={() => {
                          setHead(true);
                          setActiveSubmenu(null);
                        }}
                      >
                        {subItem.title}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="d-flex gap-2">
          {socialLinksList.map((obj, index) => {
            return (
              <Link
                key={index}
                className="text-decoration-none social_icons"
                target="_blank"
                to={obj.to}
              >
                {obj.title()}
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default Header;
